import { Icon } from '@fasstech/middle-design-system';

const TotalTableSkeleton = ({ rowCount = 1 }) => (
  <div className="border border-[#E7E7E7] rounded-md w-fit max-w-full overflow-x-auto">
    <div className="p-4 min-w-[600px]">
      <table className="min-w-full text-left text-sm text-gray-800">
        <thead>
          <tr>
            <th colSpan="3" className="flex items-center px-4 py-2 whitespace-nowrap">
              <Icon name="calculator" className="mr-2"/>
              <h2 className="text-2xl font-bold text-gray-700 pb-1">Montant total cotisation</h2>
            </th>
          </tr>
          <tr className="bg-[#F9F9FF]">
            <th/>
            <th className="px-2 py-2 font-bold whitespace-nowrap">Montant mensuel TTC</th>
            <th className="px-2 py-2 font-bold whitespace-nowrap">Montant annuel TTC</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount + 1 }).map((_, index) => (
            <tr key={index}>
              <td className="px-4 py-2">
                <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"/>
              </td>
              <td className="px-2 py-2">
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"/>
              </td>
              <td className="px-2 py-2">
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"/>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default TotalTableSkeleton;
